import { createContext, type ReactNode, useContext, useState } from 'react';

interface AffixContextType {
  affix: boolean;
  setAffix: (affix: boolean) => void;
}

const AffixContext = createContext<AffixContextType | undefined>(undefined);

export const AffixProvider = ({ children }: { children: ReactNode }) => {
  const [affix, setAffix] = useState(false);
  return <AffixContext.Provider value={{ affix, setAffix }}>{children}</AffixContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useAffixContext = () => {
  const context = useContext(AffixContext);
  if (!context) {
    throw new Error('useAffixContext must be used within a AffixProvider');
  }
  return context;
};
